import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Button} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';

class ProcessButton extends Component {
  constructor(props) {
    super(props);
    this.handleOrderClick = this.handleOrderClick.bind(this);
  }

  handleOrderClick() {
    const {dealer, agency, quantity, order, mainCode, orderRepair} = this.props;
    
    if (!quantity) {
      this.props.addMessageBoxError('Por favor ingrese la cantidad del pedido.');
      return;
    }
    this.props.createDealerEmergingOrder({
      dealer,
      agency,
      'partCode': order.code,
      'partQuantity': quantity,
      orderRepair,
    }, mainCode);
  }

  render() {
    return (
      <Button primary
        size='mini'
        content='PEDIR'
        onClick={this.handleOrderClick}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'dealer': state.session.dealerId,
    'agency': state.session.dealerAgency,
  };
};

const {
  addMessageBoxError,
  createDealerEmergingOrder,
} = Actions;

export default connect(mapStateToProps, {
  addMessageBoxError,
  createDealerEmergingOrder,
})(ProcessButton);
